import { ChatsApi } from "@/api/chats";
import { SendMessageRequest } from "@/api/chats/types";
import { useMutation } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useSendChatMessage = () => {
  const notify = useNotify();

  const { mutate: sendChatMessage, isPending } = useMutation({
    mutationFn: (body: Omit<SendMessageRequest, "isViewOnce">) =>
      ChatsApi.sendMessage({ ...body, isViewOnce: false }),
    onError: (error) => {
      notify(error, { type: "error" });
    },
  });

  return {
    sendChatMessage,
    isSendChatMessageLoading: isPending,
  };
};
